import React from 'react';
import { Input } from '../../Input';
import { Select } from '../../Select';
import { DOSAGE_UNITS, DosageUnit } from '../../../types/data';

interface VialInputsProps {
  amount: number;
  units: DosageUnit;
  onAmountChange: (value: number) => void;
  onUnitsChange: (value: DosageUnit) => void;
  error?: string;
}

export const VialInputs: React.FC<VialInputsProps> = ({
  amount,
  units,
  onAmountChange,
  onUnitsChange,
  error,
}) => {
  return (
    <>
      <Input
        label="Vial Amount"
        value={amount}
        tooltip="Enter the total quantity of peptide or liquid in the vial."
        onChange={onAmountChange}
        error={error}
      />
      <Select
        label="Vial Units"
        value={units}
        tooltip="Select the measurement units for the vial's contents, such as milligrams (mg) or milliliters (mL)."
        onChange={onUnitsChange}
        options={DOSAGE_UNITS}
      />
    </>
  );
};